<template>
  <v-dialog v-model="dialog" persistent width="800px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">
          {{ form.spotID ? 'Рекламный инструмент' : 'Новый рекламный инструмент' }}
        </v-card-title>

        <v-container>
          <v-select v-model.trim="form.spotType"
            :items="types"
            :disabled="!!form.spotID"
            placeholder="Тип инструмента"></v-select>
          <v-text-field
            v-model.trim="form.spotName"
            :error-messages="$v.form.spotName.$invalid ? 'Введите наименование' : ''"
            autofocus
            placeholder="Наименование"/>
          <v-text-field
            v-model.trim="form.spotUrl"
            :error-messages="$v.form.spotUrl.$invalid ? 'Введите корректный URL' : ''"
            placeholder="Пример (URL)"/>
        </v-container>

        <v-card-actions>
          <v-btn raised @click="dialog = false">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :disabled="$v.$invalid" :loading="loading" @click.prevent="submitAction">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '../api'
import { validationMixin } from 'vuelidate'
import { required, url } from 'vuelidate/lib/validators'

export default {
  mixins: [ validationMixin ],
  data: () => ({
    dialog: false,
    loading: false,
    form: {},
    types: [
      { text: 'Баннер', value: 'banner' },
      { text: 'Shop in shop', value: 'shop' },
      { text: 'Посадочная', value: 'landing' },
      { text: 'Рассылка', value: 'mailing' },
      { text: 'Социальные сети', value: 'social' }
    ]
  }),
  validations: {
    form: {
      spotName: { required },
      spotUrl: { url }
    }
  },
  methods: {
    hide () {
      this.dialog = false
    },
    create () {
      this.form = {}
      this.dialog = true
      this.loading = false
    },
    edit (data) {
      this.form = Object.assign({}, data)
      this.dialog = true
      this.loading = false
    },
    submitAction () {
      if ( this.$v.$invalid ) return
      this.loading = true
      api.post('spots/'+(this.form.spotID ? 'update/'+this.form.spotID : 'create'), this.form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return alert(response.data.data)
        this.hide()
        this.$emit('updated');
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>
